export enum ChatRole {
  Assistant = 'assistant',
  User = 'user',
}

export type OwlAssistPayload = {
  selectedText?: string;
  xpath?: string;
  templateId: string;
  templateType: string;
  threadId?: string;
  messages?: ChatMessage[];
};

export type ChatMessage = {
  id: string;
  role: ChatRole;
  content: string;
  streaming?: boolean;
  type?: string;
  metadata?: {
    reverted?: boolean;
    xpaths?: string[];
    updated?: boolean;
  };
};

export type ChatThreadState = {
  messages: ChatMessage[];
  status: 'in_progress' | 'done' | 'error' | 'default';
  buffer?: string;
  thread_name?: string;
  create_at?: string;
};
